import { lazy } from 'react';

export const All = lazy(() => import('./All.component'));
